import { ProdutosEgtec } from '../../core/domain/produtos-egtec/produtos-egtec';
import { ProdutosEgtecDto } from '../dto/produtos-egtec.dto';

export class ProdutosEgtecMapper {
  static toDomain(produtoDto: ProdutosEgtecDto): ProdutosEgtec {
    return {
      id: produtoDto.id,
      nome: produtoDto.nome
    };
  }

  static toDTO(produto: ProdutosEgtec): ProdutosEgtecDto {
    return {
      id: produto.id,
      nome: produto.nome
    };
  }
}
